var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarcodeMatched(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/icon/barcode match") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/barcode-match",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 0.615384615,
    x: 0.307692308,
    y: 0.307692308,
    width: 1,
    height: 11.3846154
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    fillOpacity: 0.87,
    fill: "#000000",
    x: 2,
    y: 0,
    width: 2,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 0.615384615,
    x: 5.30769231,
    y: 0.307692308,
    width: 1,
    height: 11.3846154
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 0.615384615,
    x: 8.30769231,
    y: 0.307692308,
    width: 1,
    height: 11.3846154
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 0.615384615,
    x: 11.3076923,
    y: 0.307692308,
    width: 1,
    height: 11.3846154
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    strokeOpacity: 0.87,
    stroke: "#000000",
    strokeWidth: 0.615384615,
    x: 13.3076923,
    y: 0.307692308,
    width: 1,
    height: 11.3846154
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon-/-matched-photo-copy-3",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 5,
    cy: 5,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.99038462,7.51201923 L8.49759615,3.00480769 L7.78846154,2.27163462 L3.99038462,6.08173077 L2.21153846,4.29086538 L1.50240385,5 L3.99038462,7.51201923 Z M5,0 C5.91346611,0 6.75881022,0.228363101 7.53605769,0.685096154 C8.28926659,1.11779063 8.88220938,1.71073341 9.31490385,2.46394231 C9.7716369,3.24118978 10,4.08653389 10,5 C10,5.91346611 9.7716369,6.75881022 9.31490385,7.53605769 C8.88220938,8.28926659 8.28926659,8.88220937 7.53605769,9.31490385 C6.75881022,9.7716369 5.91346611,10 5,10 C4.08653389,10 3.24118978,9.7716369 2.46394231,9.31490385 C1.71073341,8.87419651 1.11779062,8.27724736 0.685096154,7.52403846 C0.228363101,6.74679099 0,5.90545325 0,5 C0,4.09454675 0.228363101,3.25320901 0.685096154,2.47596154 C1.12580349,1.72275264 1.72275264,1.12580349 2.47596154,0.685096154 C3.25320901,0.228363101 4.09454675,0 5,0 Z",
    id: "Success-icon",
    fill: "#68AC58",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarcodeMatched);
export default __webpack_public_path__ + "static/media/barcode_matched.311bf3e03d9b883dfe393e382b848c77.svg";
export { ForwardRef as ReactComponent };